export default {
  container: {
    display: 'flex',
    marginLeft: 10,
    marginRight: 10
  },
  button: {
    display: 'flex'
  }
};
